import type { CostCatalogEntry } from "@codemation/core";

const currencyScale = 1_000_000_000;

export const FrameworkCostCatalogEntries: ReadonlyArray<CostCatalogEntry> = [
  {
    component: "chat",
    provider: "openai",
    operation: "completion.input",
    pricingKey: "demo-gpt",
    usageUnit: "input_tokens",
    currency: "USD",
    currencyScale,
    pricePerUnitMinor: 1_000,
  },
  {
    component: "chat",
    provider: "openai",
    operation: "completion.output",
    pricingKey: "demo-gpt",
    usageUnit: "output_tokens",
    currency: "USD",
    currencyScale,
    pricePerUnitMinor: 2_000,
  },
  {
    component: "chat",
    provider: "openai",
    operation: "completion.input",
    pricingKey: "gpt-4o-mini",
    usageUnit: "input_tokens",
    currency: "USD",
    currencyScale,
    pricePerUnitMinor: 150,
  },
  {
    component: "chat",
    provider: "openai",
    operation: "completion.output",
    pricingKey: "gpt-4o-mini",
    usageUnit: "output_tokens",
    currency: "USD",
    currencyScale,
    pricePerUnitMinor: 600,
  },
  {
    component: "chat",
    provider: "openai",
    operation: "completion.input",
    pricingKey: "gpt-4.1-nano",
    usageUnit: "input_tokens",
    currency: "USD",
    currencyScale,
    pricePerUnitMinor: 100,
  },
  {
    component: "chat",
    provider: "openai",
    operation: "completion.output",
    pricingKey: "gpt-4.1-nano",
    usageUnit: "output_tokens",
    currency: "USD",
    currencyScale,
    pricePerUnitMinor: 400,
  },
  {
    component: "chat",
    provider: "openai",
    operation: "completion.input",
    pricingKey: "gpt-4.1-mini",
    usageUnit: "input_tokens",
    currency: "USD",
    currencyScale,
    pricePerUnitMinor: 400,
  },
  {
    component: "chat",
    provider: "openai",
    operation: "completion.output",
    pricingKey: "gpt-4.1-mini",
    usageUnit: "output_tokens",
    currency: "USD",
    currencyScale,
    pricePerUnitMinor: 1_600,
  },
  {
    component: "chat",
    provider: "openai",
    operation: "completion.input",
    pricingKey: "gpt-4.1",
    usageUnit: "input_tokens",
    currency: "USD",
    currencyScale,
    pricePerUnitMinor: 2_000,
  },
  {
    component: "chat",
    provider: "openai",
    operation: "completion.output",
    pricingKey: "gpt-4.1",
    usageUnit: "output_tokens",
    currency: "USD",
    currencyScale,
    pricePerUnitMinor: 8_000,
  },
  {
    component: "rag",
    provider: "openai",
    operation: "embed_documents",
    pricingKey: "text-embedding-3-small",
    usageUnit: "input_tokens",
    currency: "USD",
    currencyScale,
    pricePerUnitMinor: 20,
  },
  {
    component: "ocr",
    provider: "azure_document_intelligence",
    operation: "analyze_document",
    pricingKey: "prebuilt_read",
    usageUnit: "pages",
    currency: "EUR",
    currencyScale,
    pricePerUnitMinor: 15_000_000,
  },
  {
    component: "chat",
    provider: "codemation-managed",
    operation: "completion.input",
    pricingKey: "anthropic/claude-sonnet-4-6",
    usageUnit: "input_tokens",
    currency: "USD",
    currencyScale,
    pricePerUnitMinor: 3_000,
  },
  {
    component: "chat",
    provider: "codemation-managed",
    operation: "completion.output",
    pricingKey: "anthropic/claude-sonnet-4-6",
    usageUnit: "output_tokens",
    currency: "USD",
    currencyScale,
    pricePerUnitMinor: 15_000,
  },
  {
    component: "chat",
    provider: "codemation-managed",
    operation: "completion.input",
    pricingKey: "anthropic/claude-haiku-4-5-20251001",
    usageUnit: "input_tokens",
    currency: "USD",
    currencyScale,
    pricePerUnitMinor: 800,
  },
  {
    component: "chat",
    provider: "codemation-managed",
    operation: "completion.output",
    pricingKey: "anthropic/claude-haiku-4-5-20251001",
    usageUnit: "output_tokens",
    currency: "USD",
    currencyScale,
    pricePerUnitMinor: 4_000,
  },
  {
    component: "chat",
    provider: "codemation-managed",
    operation: "completion.input",
    pricingKey: "anthropic/claude-opus-4-5-20251101",
    usageUnit: "input_tokens",
    currency: "USD",
    currencyScale,
    pricePerUnitMinor: 15_000,
  },
  {
    component: "chat",
    provider: "codemation-managed",
    operation: "completion.output",
    pricingKey: "anthropic/claude-opus-4-5-20251101",
    usageUnit: "output_tokens",
    currency: "USD",
    currencyScale,
    pricePerUnitMinor: 75_000,
  },
  {
    component: "chat",
    provider: "codemation-managed",
    operation: "completion.input",
    pricingKey: "anthropic/claude-opus-4-6",
    usageUnit: "input_tokens",
    currency: "USD",
    currencyScale,
    pricePerUnitMinor: 15_000,
  },
  {
    component: "chat",
    provider: "codemation-managed",
    operation: "completion.output",
    pricingKey: "anthropic/claude-opus-4-6",
    usageUnit: "output_tokens",
    currency: "USD",
    currencyScale,
    pricePerUnitMinor: 75_000,
  },
] as const;
